module.exports = __webpack_public_path__ + "static/media/popup_kyc_pending.033f6279.svg";